import styled from 'styled-components';
import { colors } from '@a0/quantum-web';

export const MainWrapper = styled.footer`
  max-width: 144rem;
  border-top: 0.1rem solid ${colors.neutral_n800};
  margin: 0 auto;
`;

export const TopWrapper = styled.div`
  background: ${colors.neutral_n900};
  padding: 4.8rem 1.6rem 0;

  ${({ theme }) => theme.quantum.media.tablet`
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    gap: 2.4rem;
    padding: 8rem 2.4rem 6.8rem;
  `}

  ${({ theme }) => theme.quantum.media.desktop`
    max-width: 126.4rem;
    margin: 0 auto;
  `}
`;

export const LogoWrapper = styled.div`
  display: none;

  ${({ theme }) => theme.quantum.media.tablet`
    display: block;
    grid-column: 1 / 4;

    svg {
      width: 15.6rem;
    }
  `}

  ${({ theme }) => theme.quantum.media.desktop`
    svg {
      width: 21.9rem;
    }
  `}
`;

export const Navigation = styled.nav`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4.8rem 4rem;
  margin-bottom: 5.6rem;

  ${({ theme }) => theme.quantum.media.tablet`
    grid-template-columns: repeat(3, 1fr);
    gap: 8rem 4rem;
    grid-column: 4 / 13;
    margin-bottom: 0;
  `}
`;

export const Overline = styled.span`
  font-family: 'SpaceGrotesk', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 1.2rem;
  line-height: 1.8rem;
  letter-spacing: 0.12rem;
  text-transform: uppercase;
  color: ${colors.neutral_n100};
  margin: 0 0 1.6rem;
`;

export const TitleLink = styled.a`
  text-decoration: none;
  color: ${colors.neutral_white};

  span {
    color: ${colors.neutral_white};
    position: relative;
    display: inline-block;
    :after {
      content: '→';
      padding-left: 0.5rem;
      position: absolute;
      right: -2rem;
    }
  }

  &:hover span {
    color: ${colors.indigo_i50};
  }
`;

export const List = styled.ul`
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  row-gap: 1.2rem;
  list-style-type: none;
`;

export const LinkWrapper = styled.li`
  display: flex;
  align-items: center;

  :hover a:hover {
    color: ${colors.indigo_i50};
  }
`;

export const Label = styled.span`
  display: inline-block;
  font-family: 'Inter', sans-serif;
  font-weight: 500;
  font-size: 1.1rem;
  line-height: 1.8rem;
  color: ${colors.neutral_white};
  padding: 0.1rem 0.6rem;
  background: linear-gradient(153.07deg, #3ec6eb -2.47%, #1bc99f 102.78%);
  border-radius: 0.4rem;
  margin-left: 0.8rem;
`;

export const IconsWrapper = styled.div`
  display: flex;
  column-gap: 1.6rem;

  ${({ theme }) => theme.quantum.media.tablet`
    margin-top: -5rem;
    grid-column: 10 / 13;
  `}
`;

export const BottomNavWrapper = styled.nav`
  width: 100%;
  margin: 0 auto;
  padding: 2.4rem 0;

  ${({ theme }) => theme.quantum.media.tablet`
    padding: 2.4rem;
    border-top: 0.05rem solid ${colors.neutral_n800};
  `}
  ${({ theme }) => theme.quantum.media.desktop`
    max-width: 144rem;
  `}
`;

export const BottomContainer = styled.div`
  max-width: 121.6rem;
  margin: 0 auto;
  display: flex;
  flex-direction: column-reverse;
  row-gap: 1.6rem;

  p {
    padding: 0 1.6rem;
  }

  ${({ theme }) => theme.quantum.media.tablet`
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  `}
`;

export const Links = styled.ul`
  margin: 0;
  padding: 0 1.6rem 2.4rem;
  display: flex;
  list-style-type: none;
  border-bottom: 0.05rem solid ${colors.neutral_n800};

  li + li {
    :before {
      content: '•';
      color: ${colors.neutral_n100};
      display: inline-block;
      padding: 0 0.4rem;
      ${({ theme }) => theme.quantum.media.tablet`
        padding: 0 0.8rem;
      `}
    }
  }

  ${({ theme }) => theme.quantum.media.tablet`
    border-bottom: none;
    padding: 0;
  `}
`;
